







































  import {Component, Vue, Watch} from "vue-property-decorator";
  import {bus} from "@/plugins/bus";
  import {rhizomeResource} from "@/modules/Rhizome/resources/rhizome.resource";
  import {Film} from "@/modules/Rhizome/interfaces/film.interface";
import { EventEmitter } from "@/interfaces/store-interfaces/event-emitter.interface";

  @Component({})
  export default class SearchKeyword extends Vue {
    inputField: string = '';
    savedValue: string = '';
    itemSelected: boolean = false;
    isEmptySearch: boolean = false;

    get showFavorites(): boolean {
      return this.$store.state.rhizome.showFavorites;
    }

    get filterByKeyword(): Film.IKeyword {
      return this.$store.state.rhizome.filterByKeyword;
    }

    get numberItems(): number {
      return this.$store.state.rhizome.filmsList.length;
    }

    mounted() {
      if (this.$store.state.rhizome.filterByKeywordName) {
        this.inputField = this.$store.state.rhizome.filterByKeywordName;
        this.itemSelected = true;
      }
      this.setFavoriteMode();
      this.setKeywordFilter();

      bus.$on(EventEmitter.Events.SET_KEYWORD, this.setSelected)
    }

    destroyed() {
      bus.$off(EventEmitter.Events.SET_KEYWORD, this.setSelected)
    }

    async querySearch(queryString, cb) {
      try {
        let keywords = await rhizomeResource.getKeywords(queryString);
        this.isEmptySearch = !keywords.length;

        if (this.isEmptySearch) {
          keywords = [{
            id: -1,
            value: ''
          }];
        }
        this.$store.commit('rhizome/setPropertyInState', { name: 'errorOnRequest', value: false });

        cb(keywords);
      }
      catch (e) {
        this.$store.commit('rhizome/setPropertyInState', { name: 'errorOnRequest', value: true });
      }

    }

    handleSelect(obj) {
      if (this.isEmptySearch) return;

      this.itemSelected = true;
      this.savedValue = obj.value;
      this.$store.commit('rhizome/setPropertyInState', { name: 'filterByKeywordName', value: this.savedValue });
      bus.$emit('filterListKeyword', {keywordID: obj.id, keywordValue: obj.value});
    }

    setSelected(obj: Film.IKeyword | null) {
      if (obj === null) {
        this.clearSearch()
        return
      }

      this.inputField = obj.value;
      this.itemSelected = true;
      this.savedValue = obj.value;
      this.$store.commit('rhizome/setPropertyInState', { name: 'filterByKeywordName', value: this.savedValue });
      bus.$emit('filterListKeyword', {keywordID: obj.id, keywordValue: obj.value});
    }

    onBlur() {
      if (!this.inputField) {
        this.inputField = this.savedValue;
      }
    }

    clearSearch() {
      this.inputField = '';
      this.itemSelected = false;

      if (this.showFavorites) {
        this.$store.commit('rhizome/setPropertyInState', { name: 'showFavorites', value: false });
      }
      if (this.filterByKeyword) {
        this.$store.commit('rhizome/setPropertyInState', { name: 'filterByKeyword', value: null });
      }
      this.$store.commit('rhizome/setPropertyInState', { name: 'filterByKeywordName', value: '' });

      this.$store.commit('rhizome/setPropertyInState', { name: 'errorOnRequest', value: false });
      bus.$emit('filterListKeyword', '');
    }

    setFavoriteMode() {
      if (this.showFavorites) {
        this.itemSelected = true;
        this.inputField = 'Meine Favoriten';
      }
      else {
        this.inputField = '';
        this.itemSelected = false;
      }
      if (this.$store.state.rhizome.filterByKeywordName) {
        this.inputField = this.$store.state.rhizome.filterByKeywordName;
        this.itemSelected = true;
      }
    }

    setKeywordFilter() {
      if (this.filterByKeyword) {
        this.itemSelected = true;
        this.inputField = this.filterByKeyword.value;
      }
    }

    @Watch('showFavorites')
    onShowFavoritesChange() {
      this.setFavoriteMode();
    }

    @Watch('filterByKeywordId')
    onFilterByKeywordChange() {
      this.setKeywordFilter();
    }
  }
